<div>
    <div *ngFor="let level of levels">
        <h5 class="c-label">{{ level | humanize }}</h5>
        <div class="row">
            <!-- <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="label">Background Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="sharedService.dataConfig.general[level].textConfig.backgroundColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                    >
                        <input
                            cclFormInput
                            type="text"
                            [(ngModel)]="sharedService.dataConfig.general[level].textConfig.backgroundColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{
                                    'background-color':
                                        sharedService.dataConfig.general[level].textConfig.backgroundColor
                                }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div> -->
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label [for]="'fontColor' + level">Font Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="sharedService.dataConfig.general[level].textConfig.fontColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'left'"
                    >
                        <input [id]="'fontColor' + level"
                            cclFormInput
                            type="text"
                            [(ngModel)]="sharedService.dataConfig.general[level].textConfig.fontColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{
                                    'background-color': sharedService.dataConfig.general[level].textConfig.fontColor
                                }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label [for]="'fontStyle' + level">Font Style</label></div>
                    <ccl-simple-select [formId]="'fontStyle' + level"
                        [listOfItems]="sharedService.fontStyles"
                        (valueChange)="sharedService.dataConfig.general[level].textConfig.fontStyle = $event.value"
                        [value]="sharedService.dataConfig.general[level].textConfig.fontStyle"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                        [isClearable]="false"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label [for]="'fontSize' + level">Font Size</label></div>
                    <ccl-simple-select [formId]="'fontSize' + level"
                        [listOfItems]="sharedService.fontSizes"
                        (valueChange)="sharedService.dataConfig.general[level].textConfig.fontSize = $event.value"
                        [value]="sharedService.dataConfig.general[level].textConfig.fontSize"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>
</div>
